import { FC } from 'react'
import Footer from './components/Footer/Footer'
import NavBar from './components/NavBar/NavBar'
import './App.css'
import { ContentContainer } from './components/ContentContainer/ContentContainer'
import { useDisableZoom } from './hooks/useDisableZoom'
import { InfoBlock } from './components/InfoBlock/InfoBlock'

const App: FC = () => {
  useDisableZoom()

  return (
    <div className="app-component">
      <NavBar />
      <ContentContainer>
        <div className="app-header">
          <h2 className="service-name">{'Remote Charging Control'}</h2>
          <p className="service-description">
            {
              'With Remote Charging Control, you can activate your electrified BMW Group vehicle for the smart charging functions of third-party providers.'
            }
          </p>
        </div>
        <div className="main-content">
          <InfoBlock
            title="Deprecated"
            description={
              <>
                <p>
                  <strong>The BMW Remote Charging Control Hub has moved to a new platform.</strong>
                </p>
                <p>
                  To grant your energy provider charging control to a vehicle, please ask them for an updated
                  registration process.
                </p>
                <p>
                  To manage your already-connected vehicles and locations, please go{' '}
                  <a href="https://www.bmw.co.uk/en-gb/mybmw/vehicle-overview">here</a> and select the corresponding
                  symbol per vehicle.
                </p>
              </>
            }
          />
        </div>
      </ContentContainer>
      <Footer />
    </div>
  )
}

export default App
